/**
 * [Session C-A CP-2 (P0b)] KDEFMatchupCard - simplified card for K and
 * DEF positions per spec §3.9. K/DEF do NOT get the five-axis radar -
 * they get a distinct card with four rows:
 *
 *   • Matchup score       - from position_matchup_context (CP-6 wires)
 *   • Implied opp. total  - from team_week_schedule_context (CP-6 wires)
 *   • Availability        - from player_metrics.status (LIVE now)
 *   • ADP rank            - from player_metrics.adp_rank_* (LIVE now)
 *
 * "data pending" is shown for CP-6-gated rows, matching the CP-1
 * axis-bullet fallback pattern for honest empty state.
 */
export function KDEFMatchupCard({
  position,
  team,
  byeWeek,
  availability,
  adpRank,
  matchupScore = null,
  impliedOpponentTotal = null,
}) {
  const isKicker = (position || "").toUpperCase() === "K";
  return (
    <div
      data-testid="kdef-matchup-card"
      className="rounded-md bg-[#0F0F12] border-2 border-[#FF6B00] px-3 py-2 flex flex-col gap-1.5"
      style={{ minHeight: 210 }}
    >
      <p className="font-display font-black text-[10px] uppercase tracking-[0.22em] text-[#FF6B00] text-center">
        {isKicker ? "Kicker Matchup" : "Defense Matchup"}
      </p>
      <p className="font-body text-[10px] text-[#A0A0A0] text-center">
        {(team || "FA").toUpperCase()}
        {byeWeek != null ? ` · Bye Wk ${byeWeek}` : ""}
      </p>

      <_KDEFRow
        label="Matchup score"
        value={matchupScore}
        formatter={(v) => `${Math.round(v * 100)}%`}
        testid="kdef-matchup-score"
      />
      <_KDEFRow
        label={isKicker ? "Opp. implied total" : "Opp. implied total (low = better)"}
        value={impliedOpponentTotal}
        formatter={(v) => v.toFixed(1)}
        testid="kdef-opp-implied-total"
      />
      <_KDEFRow
        label="Availability"
        value={availability}
        formatter={(v) => String(v)}
        testid="kdef-availability"
      />
      <_KDEFRow
        label="ADP rank"
        value={adpRank}
        formatter={(v) => `#${v}`}
        testid="kdef-adp-rank"
      />
    </div>
  );
}

function _KDEFRow({ label, value, formatter, testid }) {
  const hasValue = value !== null && value !== undefined && value !== "";
  return (
    <div className="flex items-center justify-between gap-2" data-testid={testid}>
      <p className="font-display font-bold text-[11px] uppercase tracking-[0.12em] text-[#A0A0A0]">
        {label}
      </p>
      <p
        className={`font-body ${hasValue ? "text-[#F5F5F5]" : "text-[#666] italic"} text-[12px]`}
      >
        {hasValue ? formatter(value) : "data pending"}
      </p>
    </div>
  );
}

export default KDEFMatchupCard;
